export const connectEvents = (store, socket) => {
  // Normal event actions
  socket.on('event-delete', data => store.dispatch({ type: 'EVENTS_DELETED', ...data }))
  socket.on('event-update', data => store.dispatch({ type: 'EVENTS_UPDATED', ...data }))

  // Leave
  socket.on('leave-create', data => store.dispatch({ type: 'EVENTS_LEAVE_CREATED', ...data }))

  // Cancelling and restoring
  socket.on('event-cancel', data => {
    const {
      settings: { showCancelledShift }
    } = store.getState()
    store.dispatch({ type: 'EVENTS_CANCELLED', ...data, showCancelledShift })
  })
  socket.on('event-restore', data => {
    const {
      settings: { showCancelledShift }
    } = store.getState()
    store.dispatch({ type: 'EVENTS_RESTORED', ...data, showCancelledShift })
  })

  // TODO
  // socket.on('scheduleContactEvent', data => store.dispatch({ type: 'EVENTS_UPDATED', ...data }))
}

export const disconnectEvents = socket => {
  // socket.off('scheduleContactEvent')
  socket.off('event-update')
  socket.off('event-delete')
  socket.off('event-cancel')
  socket.off('event-restore')
  socket.off('leave-create')
}
